import * as i0 from '@angular/core';
import { Component, Injectable, inject, EventEmitter, Output, ViewEncapsulation, ViewChild, Input, NgModule } from '@angular/core';
import * as i4$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@angular/forms';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import * as i7 from '@engineering11/ui-lib/e11-button';
import { E11ButtonModule } from '@engineering11/ui-lib/e11-button';
import * as i6 from '@engineering11/ui-lib/e11-input';
import { E11InputModule } from '@engineering11/ui-lib/e11-input';
import { E11InputCheckboxModule } from '@engineering11/ui-lib/e11-input-checkbox';
import * as i8 from '@engineering11/ui-lib/e11-input-errors';
import { E11FormValidationService, Validation, E11InputErrorsModule } from '@engineering11/ui-lib/e11-input-errors';
import * as i3$1 from '@engineering11/ui-lib/e11-loader-dots';
import { E11LoaderDotsModule } from '@engineering11/ui-lib/e11-loader-dots';
import { E11PanelModule } from '@engineering11/ui-lib/e11-panel';
import * as i9 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i5$1 from 'ng-recaptcha';
import { RecaptchaModule } from 'ng-recaptcha';
import { Auth, user, onIdTokenChanged, onAuthStateChanged, signInWithEmailAndPassword, signInWithCustomToken, createUserWithEmailAndPassword, signInWithPopup, getIdTokenResult, sendEmailVerification, fetchSignInMethodsForEmail, sendPasswordResetEmail, reauthenticateWithCredential, updatePassword, verifyPasswordResetCode, confirmPasswordReset, applyActionCode } from '@angular/fire/auth';
import * as i4 from '@engineering11/web-api-error';
import { e11Error } from '@engineering11/web-api-error';
import { GoogleAuthProvider, OAuthProvider, EmailAuthProvider } from 'firebase/auth';
import { Observable, EMPTY, from, firstValueFrom, Subject, fromEvent, timer, pipe } from 'rxjs';
import { distinctUntilChanged, tap, map, filter, mergeWith, throttleTime } from 'rxjs/operators';
import { RestApiClient } from '@engineering11/web-api-rest';
import * as i3 from '@engineering11/web-ui-helpers';
import * as i5 from '@engineering11/ui-lib/e11-notifications';
import { E11NotificationMessage } from '@engineering11/ui-lib/e11-notifications';
import { isNotNil } from '@engineering11/utility';
import { LetDirective } from '@ngrx/component';
import { intervalToDuration, formatDuration } from 'date-fns';
import * as i2 from '@engineering11/ui-lib/e11-modal';
import { emailVerified, customClaims, redirectLoggedInTo, canActivate } from '@angular/fire/auth-guard';
import jwt_decode from 'jwt-decode';

class AuthComponent {
    constructor() { }
    ngOnInit() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: AuthComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: AuthComponent, selector: "lib-auth", ngImport: i0, template: ` <p>auth works!</p> `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: AuthComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-auth', template: ` <p>auth works!</p> ` }]
        }], ctorParameters: () => [] });

class BaseAuthConfigProvider {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BaseAuthConfigProvider, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BaseAuthConfigProvider, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BaseAuthConfigProvider, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

var PLATFORM_ADMIN_ROLES;
(function (PLATFORM_ADMIN_ROLES) {
    PLATFORM_ADMIN_ROLES["SUPER_USER"] = "SuperUser";
    PLATFORM_ADMIN_ROLES["CUSTOMER_SUCCESS"] = "CustomerSuccess";
    PLATFORM_ADMIN_ROLES["MARKETING"] = "Marketing";
    PLATFORM_ADMIN_ROLES["ENGINEERING"] = "Engineering";
    PLATFORM_ADMIN_ROLES["PRODUCT_MANAGEMENT"] = "ProductManagement";
    PLATFORM_ADMIN_ROLES["TECHNICAL_SUPPORT"] = "TechnicalSupport";
})(PLATFORM_ADMIN_ROLES || (PLATFORM_ADMIN_ROLES = {}));
const AUTH_ERRORS = Object.freeze({
    UNKNOWN: 'auth/unknown',
    FIREBASE_UNKNOWN: 'auth/firebase-unhandled',
    WRONG_PASSWORD: 'auth/wrong-password',
    USER_NOT_FOUND: 'auth/user-not-found',
    NO_USER: 'auth/no-user',
    TOO_MANY_REQUESTS: 'auth/too-many-requests',
    INVALID_EMAIL: 'auth/invalid-email',
    RE_AUTH_FAILED: 'auth/re-auth-failed', // consider making more granular
    INVALID_ACTION_CODE: 'auth/invalid-action-code',
    EXPIRED_ACTION_CODE: 'auth/expired-action-code',
    USER_DISABLED: 'auth/user-disabled',
    WEAK_PASSWORD: 'auth/weak-password',
    EMAIL_IN_USE: 'auth/email-already-in-use',
    NO_VERIFY_CODE: 'auth/no-verify-code',
    NETWORK_REQUEST_FAILED: 'auth/network-request-failed',
    MISSING_CONFIG: 'auth/missing-config',
    NO_TENANT_ID: 'auth/missing-tenant-id',
});
var AUTH_BASE_ROLES;
(function (AUTH_BASE_ROLES) {
    AUTH_BASE_ROLES["ADMINISTRATOR"] = "Administrator";
    AUTH_BASE_ROLES["CONSUMER"] = "Consumer";
})(AUTH_BASE_ROLES || (AUTH_BASE_ROLES = {}));
var TENANT_ROLES;
(function (TENANT_ROLES) {
    TENANT_ROLES["TENANT_ADMIN"] = "TenantAdmin";
    TENANT_ROLES["CLIENT_EDITOR"] = "ClientEditor";
    TENANT_ROLES["CLIENT_VIEWER"] = "ClientViewer";
})(TENANT_ROLES || (TENANT_ROLES = {}));

const AUTH_INVALID_CREDENTIAL = 'The email or password you entered is incorrect. Please try again.';
class AuthService {
    constructor(app, errorHandler, authConfigProvider) {
        this.app = app;
        this.errorHandler = errorHandler;
        this.authConfigProvider = authConfigProvider;
        this.user = null;
        this.auth = inject(Auth);
        this.analyticsService = this.authConfigProvider.analyticsService;
        this.user$ = user(this.auth).pipe(distinctUntilChanged(), tap((u) => {
            this.user = u;
            this.app.tick();
            if (u && this.analyticsService)
                this.analyticsService.setUserId(u.uid);
        }));
        this.user$.subscribe();
        onIdTokenChanged(this.auth, () => { });
    }
    onAuthStateChanged() {
        return new Observable((observer) => {
            onAuthStateChanged(this.auth, (user) => (!!user ? observer.next(user) : EMPTY), (e) => this.errorHandler.handleError(e), () => observer.complete());
        });
    }
    onIdTokenChange() {
        return new Observable((observer) => {
            onIdTokenChanged(this.auth, (user) => {
                user
                    ?.getIdToken(true)
                    .then((token) => observer.next(token))
                    .catch((e) => this.errorHandler.handleError(e));
            }, (e) => this.errorHandler.handleError(e), () => observer.complete());
        });
    }
    setTenantId(tenantId) {
        this.auth.tenantId = tenantId;
        return this;
    }
    async getTenantId() {
        const tenantId = this.auth.tenantId;
        if (!tenantId) {
            throw e11Error({
                type: AUTH_ERRORS.NO_TENANT_ID,
                title: 'We ran into an issue. Missing tenant ID.',
                message: 'A required tenant ID was not found on this account.',
            });
        }
        return tenantId;
    }
    emailPasswordSignIn(email, password) {
        return this.authAsyncHandler(signInWithEmailAndPassword(this.auth, email, password), 'login');
    }
    customTokenSignIn(token) {
        return this.authAsyncHandler(signInWithCustomToken(this.auth, token), 'login');
    }
    emailPasswordSignUp(email, password) {
        return this.authAsyncHandler(createUserWithEmailAndPassword(this.auth, email, password), 'register');
    }
    googleSignIn() {
        const provider = new GoogleAuthProvider();
        return this.authAsyncHandler(signInWithPopup(this.auth, provider), 'login');
    }
    appleSignIn() {
        const provider = new OAuthProvider('apple.com');
        return this.authAsyncHandler(signInWithPopup(this.auth, provider), 'login');
    }
    signOut(redirectUrl = '/') {
        this.auth.signOut().then(() => {
            location.replace(redirectUrl);
            if (this.analyticsService)
                this.analyticsService.logEvent('logout');
        });
    }
    signOutAndClearStorages(redirectUrl = '/') {
        localStorage.clear();
        sessionStorage.clear();
        this.signOut(redirectUrl);
    }
    /**
     * @deprecated use getIdToken() instead
     * @returns
     */
    getCustomClaims() {
        const tokenToClaims = (token) => token?.claims;
        const claimsObservable = from(getIdTokenResult(this.getCurrentUserOrError())).pipe(map(tokenToClaims));
        return firstValueFrom(claimsObservable);
    }
    /**
     *
     * @returns The logged in users idToken
     * Example:
     * {
              "claims": {
                  "name": "TheGoldenJet",
                  "appUserId": "uuJ2FoHvkHYwYnuGGuZ7N5fNN5k2",
                  "customerKey": "uuJ2FoHvkHYwYnuGGuZ7N5fNN5k2",
                  "termsVersionAccepted": 2,
                  "roles": [
                      "Consumer"
                  ],
                  "iss": "https://securetoken.google.com/e11-sandbox",
                  "aud": "e11-sandbox",
                  "auth_time": 1672519689,
                  "user_id": "uuJ2FoHvkHYwYnuGGuZ7N5fNN5k2",
                  "sub": "uuJ2FoHvkHYwYnuGGuZ7N5fNN5k2",
                  "iat": 1672522083,
                  "exp": 1672525683,
                  "email": "bobby.hull@cnect.dev",
                  "email_verified": false,
                  "firebase": {
                      "identities": {
                          "email": [
                              "bobby.hull@cnect.dev"
                          ]
                      },
                      "sign_in_provider": "password"
                  }
              },
              "token": "eyJhbGciOiJSUzI1NiIsImtpZCI6Ijg3NTNiYmFiM2U4YzBmZjdjN2ZiNzg0ZWM5MmY5ODk3YjVjZDkwN2QiLCJ0eXAiOiJKV1QifQ.eyJuYW1lIjoiVGhlR29sZGVuSmV0IiwiYXBwVXNlcklkIjoidXVKMkZvSHZrSFl3WW51R0d1WjdONWZOTjVrMiIsImN1c3RvbWVyS2V5IjoidXVKMkZvSHZrSFl3WW51R0d1WjdONWZOTjVrMiIsInRlcm1zVmVyc2lvbkFjY2VwdGVkIjoyLCJyb2xlcyI6WyJDb25zdW1lciJdLCJpc3MiOiJodHRwczovL3NlY3VyZXRva2VuLmdvb2dsZS5jb20vZTExLXNhbmRib3giLCJhdWQiOiJlMTEtc2FuZGJveCIsImF1dGhfdGltZSI6MTY3MjUxOTY4OSwidXNlcl9pZCI6InV1SjJGb0h2a0hZd1ludUdHdVo3TjVmTk41azIiLCJzdWIiOiJ1dUoyRm9IdmtIWXdZbnVHR3VaN041Zk5ONWsyIiwiaWF0IjoxNjcyNTIyMDgzLCJleHAiOjE2NzI1MjU2ODMsImVtYWlsIjoiYm9iYnkuaHVsbEBjbmVjdC5kZXYiLCJlbWFpbF92ZXJpZmllZCI6ZmFsc2UsImZpcmViYXNlIjp7ImlkZW50aXRpZXMiOnsiZW1haWwiOlsiYm9iYnkuaHVsbEBjbmVjdC5kZXYiXX0sInNpZ25faW5fcHJvdmlkZXIiOiJwYXNzd29yZCJ9fQ.QFYahNylQP-QLC03X0ulw9JvycgLEjaJrdry3Jp3l08XZNNuEFzYnwsZ0G6ZjJbs0bzOsZ1h9-nZxB7zmWu0Z4eSxmXgQJshVibc1EK2WamCHXwowap7Iyfuq19XQQW-SaN9vN1YD5I7RrP0cF8_Opg5HcbEYhcr-7WMXd1rBOnjAXysGaf3UuOn9CP6lHFFlq23TWI6oQ3sUSZOSCjY3hnOPLmeLw4JBllyd7sPplWSP0oJyi-eng_ZaD-L6vYZ3cx8szzICarbuUDa1S7HdQMzIwXlJHrpVeycmTm3hbhwquSHTgyzCnG2NBfyCEsxlGOdkXBELW4Wza0vlXhSNQ",
              "authTime": "Sat, 31 Dec 2022 20:48:09 GMT",
              "issuedAtTime": "Sat, 31 Dec 2022 21:28:03 GMT",
              "expirationTime": "Sat, 31 Dec 2022 22:28:03 GMT",
              "signInProvider": "password",
              "signInSecondFactor": null
          }
     */
    async getIdToken(forceRefresh = true) {
        const user = this.auth.currentUser;
        if (user) {
            const idTokenResult = await getIdTokenResult(user, forceRefresh);
            return idTokenResult;
        }
        return undefined;
    }
    async sendVerificationMail() {
        const user = this.auth.currentUser;
        if (user)
            await sendEmailVerification(user);
    }
    fetchSignInMethodsForEmail(email) {
        return this.authAsyncHandler(fetchSignInMethodsForEmail(this.auth, email));
    }
    async sendPasswordResetEmail(email) {
        return this.authAsyncHandler(sendPasswordResetEmail(this.auth, email), 'send-reset-email');
    }
    async reAuthenticateWithCredential(password) {
        const user = this.getCurrentUserOrError();
        const credentials = EmailAuthProvider.credential(user.email, password);
        return await reauthenticateWithCredential(user, credentials);
    }
    async updatePassword(oldPassword, newPassword) {
        const user = this.getCurrentUserOrError();
        const { res, err } = await this.authAsyncHandler(this.reAuthenticateWithCredential(oldPassword), 're-auth');
        if (err)
            return { err };
        return this.authAsyncHandler(updatePassword(user, newPassword), 'update-password');
    }
    async isEmailAvailable(email) {
        let { res, err } = await this.fetchSignInMethodsForEmail(email.trim());
        if (res && res.length > 0) {
            return false;
        }
        return true;
    }
    /**
     * @deprecated use isEmailAvailable - clearer name
     */
    async checkEmailAvailability(email) {
        return this.isEmailAvailable(email);
    }
    async handleResetPassword(newPassword, actionCode) {
        const { res, err } = await this.authAsyncHandler(verifyPasswordResetCode(this.auth, actionCode), 'verify-reset-code');
        if (err)
            return { err };
        const { err: err2 } = await this.authAsyncHandler(confirmPasswordReset(this.auth, actionCode, newPassword), 'confirm-reset');
        return { res, err: err2 };
    }
    async handleVerifyEmail(actionCode) {
        return this.authAsyncHandler(applyActionCode(this.auth, actionCode), 'verify-email');
    }
    getCurrentUserOrError() {
        const user = this.auth.currentUser;
        if (!user)
            throw e11Error({
                type: AUTH_ERRORS.NO_USER,
                title: 'We ran into an issue. Please log in again.',
                message: 'Attempted to get current user, but none was found',
            });
        return user;
    }
    async authAsyncHandler(promise, action) {
        const { res, err } = await this.errorHandler.asyncHandler(promise, getAuthErrorData);
        if (res && action && this.analyticsService)
            this.analyticsService.logEvent(action);
        return { res, err };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: AuthService, deps: [{ token: i0.ApplicationRef }, { token: i4.E11ErrorHandlerService }, { token: BaseAuthConfigProvider }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: AuthService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: AuthService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i0.ApplicationRef }, { type: i4.E11ErrorHandlerService }, { type: BaseAuthConfigProvider }] });
function getAuthErrorData(err) {
    const UNKNOWN_ERROR = 'An error has occurred. Please try again.';
    const LOCKED_ERROR = 'Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later.';
    const { code, message } = err;
    switch (code) {
        case 'auth/too-many-requests':
            return { type: AUTH_ERRORS.TOO_MANY_REQUESTS, title: LOCKED_ERROR, message };
        case 'auth/invalid-email':
            return {
                type: AUTH_ERRORS.INVALID_EMAIL,
                title: "This email doesn't look right. Please review and try again.",
                level: 'none',
                message,
            };
        case 'auth/wrong-password':
            return {
                type: AUTH_ERRORS.WRONG_PASSWORD,
                title: 'The email or password you entered is incorrect. Please try again.',
                level: 'none',
                message,
            };
        case 'auth/user-not-found':
            return {
                type: AUTH_ERRORS.USER_NOT_FOUND,
                title: 'No user with this email was found. Do you need to create an account?',
                level: 'none',
                message,
            };
        case 'auth/user-disabled':
            return {
                type: AUTH_ERRORS.USER_DISABLED,
                title: 'This user has been disabled. If you believe this to be in error, please contact support.',
                message,
            };
        case 'auth/invalid-action-code':
            return {
                type: AUTH_ERRORS.INVALID_ACTION_CODE,
                title: 'This action code is invalid. This can happen if the code is malformed, expired, or has already been used. Please generate a new code and try again.',
                message,
            };
        case 'auth/expired-action-code':
            return {
                type: AUTH_ERRORS.EXPIRED_ACTION_CODE,
                title: 'This action code is expired. Please repeat the steps taken to get this code (such as by generating an email with a link) and try again.',
                level: 'none',
                message,
            };
        case 'auth/weak-password':
            return {
                type: AUTH_ERRORS.WEAK_PASSWORD,
                title: 'Password too weak. Please try another.',
                level: 'none',
                message,
            };
        case 'auth/email-already-in-use':
            return {
                type: AUTH_ERRORS.EMAIL_IN_USE,
                title: 'Email already in use. Do you need to login?',
                level: 'none',
                message,
            };
        case 'auth/network-request-failed':
            return {
                type: AUTH_ERRORS.NETWORK_REQUEST_FAILED,
                title: 'Network request failed - please ensure you have a stable network connection and try again',
                level: 'none',
                message,
            };
        case undefined:
            return { type: AUTH_ERRORS.UNKNOWN, title: UNKNOWN_ERROR, message };
        default:
            return { type: AUTH_ERRORS.FIREBASE_UNKNOWN, title: err.message ?? UNKNOWN_ERROR, message };
    }
}

class AuthRestService {
    constructor(authConfigProvider, authService, notificationService, errorHandler) {
        this.authConfigProvider = authConfigProvider;
        this.authService = authService;
        this.notificationService = notificationService;
        this.errorHandler = errorHandler;
    }
    async sendVerificationEmail(emailVerificationRequest) {
        const token = await this.getUserOrError().getIdToken(true);
        const restClient = this.createRestClient(token);
        await restClient
            .put(`verify-email`, emailVerificationRequest)
            .toPromise()
            .catch((err) => {
            throw this.handleError(err);
        });
    }
    async resendVerificationEmail(email) {
        const request = { email };
        const token = await this.getUserOrError().getIdToken(true);
        const restClient = this.createRestClient(token);
        await restClient
            .put(`verify-email/resend`, request)
            .toPromise()
            .catch((err) => {
            throw this.handleError(err);
        });
    }
    async sendVerificationEmailWithCustomLink(emailVerificationRequest) {
        const token = await this.getUserOrError().getIdToken(true);
        const restClient = this.createRestClient(token);
        await restClient
            .put(`verify-email`, emailVerificationRequest, { version: '2' })
            .toPromise()
            .catch((err) => {
            throw this.handleError(err);
        });
    }
    async resendVerificationEmailWithCustomLink(email) {
        const request = { email };
        const token = await this.getUserOrError().getIdToken(true);
        const restClient = this.createRestClient(token);
        await restClient
            .put(`verify-email/resend`, request, { version: '2' })
            .toPromise()
            .catch((err) => {
            throw this.handleError(err);
        });
    }
    async sendVerificationEmailWithEmail(email) {
        const request = { email };
        return this.sendVerificationEmail(request);
    }
    async sendPasswordResetEmailWithEmail(email) {
        const resetRequest = {
            email,
            bootstrapId: this.authConfigProvider.config.bootstrapId,
        };
        return this.sendPasswordResetEmail(resetRequest).catch((err) => {
            throw this.handleError(err);
        });
    }
    async sendPasswordResetEmailWithCustomLink(email) {
        const resetRequest = {
            email,
            bootstrapId: this.authConfigProvider.config.bootstrapId,
        };
        const restClient = this.createRestClient();
        const response = await restClient
            .put(`password-reset`, resetRequest, { version: '2' })
            .toPromise()
            .catch((err) => {
            throw this.handleError(err);
        });
        return response;
    }
    async sendPasswordResetEmail(passwordResetRequest) {
        const restClient = this.createRestClient();
        await restClient
            .put(`password-reset`, passwordResetRequest)
            .toPromise()
            .catch((err) => {
            throw this.handleError(err);
        });
    }
    createRestClient(token = '') {
        return new RestApiClient({
            baseUrl: this.authConfigProvider.config.authBaseURL,
            token: token,
            throwNon200s: true,
        });
    }
    handleError(err) {
        this.notificationService.popNotificationFromError(err);
        return this.errorHandler.handleError(err);
    }
    getUserOrError() {
        if (!this.authService.user) {
            throw e11Error({
                type: AUTH_ERRORS.NO_USER,
                title: 'User not found',
                message: 'User is not found. Please log in again',
            });
        }
        return this.authService.user;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: AuthRestService, deps: [{ token: BaseAuthConfigProvider }, { token: AuthService }, { token: i3.NotificationService }, { token: i4.E11ErrorHandlerService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: AuthRestService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: AuthRestService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: BaseAuthConfigProvider }, { type: AuthService }, { type: i3.NotificationService }, { type: i4.E11ErrorHandlerService }] });
function missingConfigErrorData(missingConfig) {
    return {
        type: AUTH_ERRORS.MISSING_CONFIG,
        title: 'A configuration error occurred. Our engineers have been notified and are working to fix the issue',
        message: `Missing configuration, ${missingConfig} is undefined. Configure Auth module with an IAuthConfig model`,
    };
}

class FormCustomValidationService extends E11FormValidationService {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: FormCustomValidationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: FormCustomValidationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: FormCustomValidationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class ForgotPasswordComponent {
    constructor(authRestService, formBuilder, customValidator, e11ErrorHandler, notificationService) {
        this.authRestService = authRestService;
        this.formBuilder = formBuilder;
        this.customValidator = customValidator;
        this.e11ErrorHandler = e11ErrorHandler;
        this.notificationService = notificationService;
        this.continueClicked = new EventEmitter();
        this.formSubmitted = new EventEmitter(); // Emits email
        this.formRecover = new FormGroup({}); // ! Do NOT type new forms as "any" - this is from the Angular 14 migration
        this.emailFC = new FormControl({});
        this.formRecoverSubmitted = false;
        this.processed = false;
        this.loading = false;
    }
    ngOnInit() {
        this.createForm();
    }
    createForm() {
        this.formRecover = this.formBuilder.group({
            email: new FormControl('', [Validators.required, this.customValidator.emailValidator()]),
        });
        this.emailFC = this.formRecover.get('email');
    }
    get f() {
        return this.formRecover.controls;
    }
    async onSubmit() {
        this.formRecoverSubmitted = true;
        if (this.formRecover.valid) {
            this.loading = true;
            const email = this.formRecover.get('email')?.value;
            try {
                await this.authRestService.sendPasswordResetEmailWithCustomLink(email);
                this.processed = true;
                this.formSubmitted.emit(email);
            }
            catch (error) {
                // Error handling performed within service
            }
            finally {
                this.loading = false;
                this.formRecover.reset();
                this.formRecoverSubmitted = false;
            }
        }
    }
    tryAgain() {
        this.processed = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ForgotPasswordComponent, deps: [{ token: AuthRestService }, { token: i1.FormBuilder }, { token: FormCustomValidationService }, { token: i4.E11ErrorHandlerService }, { token: i5.E11NotificationsService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ForgotPasswordComponent, selector: "auth-forgot-password", outputs: { continueClicked: "continueClicked", formSubmitted: "formSubmitted" }, ngImport: i0, template: "<form *ngIf=\"!processed\" class=\"\" [formGroup]=\"formRecover\" (ngSubmit)=\"onSubmit()\" novalidate>\n  <div>\n    <e11-input\n      [type]=\"'email'\"\n      name=\"email\"\n      id=\"email_formLogin_body\"\n      label=\"{{ 'Email' | translate }}\"\n      [size]=\"'md'\"\n      [borderGlow]=\"'primary'\"\n      [parentForm]=\"formRecover\"\n      [autofocus]=\"false\"\n      formControlName=\"email\"\n      autocomplete=\"off\"\n      [hasError]=\"(f.email.errors && f.email.dirty) || (f.email.invalid && formRecoverSubmitted)\"\n    >\n      <e11-input-errors [parentForm]=\"formRecover\" [formControl]=\"f.email\" label=\"{{ 'Email' | translate }}\"></e11-input-errors>\n    </e11-input>\n  </div>\n\n  <div class=\"e11-w-full\">\n    <e11-button\n      [color]=\"'primary-accent'\"\n      [type]=\"'submit'\"\n      value=\"{{ 'Continue' | translate }}\"\n      [loading]=\"loading\"\n      [disabled]=\"loading\"\n      [display]=\"'block'\"\n    >\n    </e11-button>\n  </div>\n</form>\n\n<ng-container *ngIf=\"processed\">\n  <div class=\"e11-text-center\">\n    <span class=\"material-icons-outlined md-48\"> email </span>\n  </div>\n  <p class=\"e11-text-center e11-text-skin-base\">\n    {{ \"Please check your email inbox for an email from us to reset your password.\" | translate }}\n  </p>\n  <div class=\"e11-w-full\">\n    <e11-button\n      id=\"button_RecoverContinue\"\n      value=\"{{ 'I got the email. Continue to log in' | translate }}\"\n      [color]=\"'primary-accent'\"\n      [type]=\"'button'\"\n      [display]=\"'block'\"\n      (click)=\"continueClicked.emit()\"\n    >\n    </e11-button>\n  </div>\n  <p class=\"e11-mt-2 e11-text-center e11-text-sm e11-text-skin-base\">\n    {{ \"Didn't get an email?\" | translate }}\n    <a (click)=\"tryAgain()\" class=\"e11-font-medium e11-text-skin-secondary hover:e11-text-skin-secondary e11-cursor-pointer\">\n      {{ \"Try again\" | translate }}\n    </a>\n  </p>\n</ng-container>\n", styles: [""], dependencies: [{ kind: "directive", type: i4$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i6.E11InputComponent, selector: "e11-input", inputs: ["containerClass", "inputClass", "hintText", "label", "type", "size", "style", "placeholder", "maxLength", "max", "name", "id", "iconLeft", "iconLeftBorder", "required", "hasError", "labelColor", "borderGlow", "checkIcon", "clearIcon", "autofocus", "togglePassword", "hasButton", "buttonText", "buttonIcon", "buttonIconType", "buttonIconSize", "readonly", "disabled", "disabledText", "autocomplete", "formControlName", "isRounded", "parentForm", "tooltipConfig", "icon", "iconType", "iconSize", "darkMode", "context", "enforceCharacterLimit", "showCharacterLimitWarning", "loading", "leadingIcon", "trailingIcon"], outputs: ["change", "focus", "blur"] }, { kind: "component", type: i7.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i8.E11InputErrorsComponent, selector: "e11-input-errors", inputs: ["formControl", "parentForm", "label", "formSubmitted", "suppressError", "messageOverrides"] }, { kind: "pipe", type: i9.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ForgotPasswordComponent, decorators: [{
            type: Component,
            args: [{ selector: 'auth-forgot-password', template: "<form *ngIf=\"!processed\" class=\"\" [formGroup]=\"formRecover\" (ngSubmit)=\"onSubmit()\" novalidate>\n  <div>\n    <e11-input\n      [type]=\"'email'\"\n      name=\"email\"\n      id=\"email_formLogin_body\"\n      label=\"{{ 'Email' | translate }}\"\n      [size]=\"'md'\"\n      [borderGlow]=\"'primary'\"\n      [parentForm]=\"formRecover\"\n      [autofocus]=\"false\"\n      formControlName=\"email\"\n      autocomplete=\"off\"\n      [hasError]=\"(f.email.errors && f.email.dirty) || (f.email.invalid && formRecoverSubmitted)\"\n    >\n      <e11-input-errors [parentForm]=\"formRecover\" [formControl]=\"f.email\" label=\"{{ 'Email' | translate }}\"></e11-input-errors>\n    </e11-input>\n  </div>\n\n  <div class=\"e11-w-full\">\n    <e11-button\n      [color]=\"'primary-accent'\"\n      [type]=\"'submit'\"\n      value=\"{{ 'Continue' | translate }}\"\n      [loading]=\"loading\"\n      [disabled]=\"loading\"\n      [display]=\"'block'\"\n    >\n    </e11-button>\n  </div>\n</form>\n\n<ng-container *ngIf=\"processed\">\n  <div class=\"e11-text-center\">\n    <span class=\"material-icons-outlined md-48\"> email </span>\n  </div>\n  <p class=\"e11-text-center e11-text-skin-base\">\n    {{ \"Please check your email inbox for an email from us to reset your password.\" | translate }}\n  </p>\n  <div class=\"e11-w-full\">\n    <e11-button\n      id=\"button_RecoverContinue\"\n      value=\"{{ 'I got the email. Continue to log in' | translate }}\"\n      [color]=\"'primary-accent'\"\n      [type]=\"'button'\"\n      [display]=\"'block'\"\n      (click)=\"continueClicked.emit()\"\n    >\n    </e11-button>\n  </div>\n  <p class=\"e11-mt-2 e11-text-center e11-text-sm e11-text-skin-base\">\n    {{ \"Didn't get an email?\" | translate }}\n    <a (click)=\"tryAgain()\" class=\"e11-font-medium e11-text-skin-secondary hover:e11-text-skin-secondary e11-cursor-pointer\">\n      {{ \"Try again\" | translate }}\n    </a>\n  </p>\n</ng-container>\n" }]
        }], ctorParameters: () => [{ type: AuthRestService }, { type: i1.FormBuilder }, { type: FormCustomValidationService }, { type: i4.E11ErrorHandlerService }, { type: i5.E11NotificationsService }], propDecorators: { continueClicked: [{
                type: Output
            }], formSubmitted: [{
                type: Output
            }] } });

const ERROR_HANDLING = {
    USER_NAME_MIN_LENGTH: 8,
    USER_NAME_MAX_LENGTH: 50,
    PASSWORD_MIN_LENGTH: 8,
    PASSWORD_MAX_LENGTH: 24,
    EMAIL_MIN_LENGTH: 7,
    EMAIL_MAX_LENGTH: 100,
    FIRST_NAME_MIN_LENGTH: 1,
    FIRST_NAME_MAX_LENGTH: 100,
    LAST_NAME_MIN_LENGTH: 1,
    LAST_NAME_MAX_LENGTH: 100,
    COMPANY_NAME_MIN_LENGTH: 5,
    COMPANY_NAME_MAX_LENGTH: 100,
    PHONE_MIN_LENGTH: 10,
    PHONE_MAX_LENGTH: 20,
    ADDRESS_MIN_LENGTH: 4,
    ADDRESS_MAX_LENGTH: 100,
    STATE_REQUIRED_LENGTH: 2,
    ZIP_MIN_LENGTH: 5,
    ZIP_MAX_LENGTH: 10,
    COUNTRY_REQUIRED_LENGTH: 2,
};

class IAuthService {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: IAuthService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: IAuthService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: IAuthService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class LoginComponent {
    constructor(formBuilder, authService, customValidator) {
        this.formBuilder = formBuilder;
        this.authService = authService;
        this.customValidator = customValidator;
        this.formLogin = new FormGroup({}); // ! Do NOT type new forms as "any" - this is from the Angular 14 migration
        this.formLoginSubmitted = false;
        this.loading = false;
        this.onForgottenPassword = new EventEmitter();
        this.onSubmit = new EventEmitter();
        this.onError = new EventEmitter();
    }
    ngOnInit() {
        this.formLogin = this.formBuilder.group({
            email: new FormControl('', [Validators.required, this.customValidator.emailValidator()]),
            password: new FormControl('', [
                Validators.required,
                Validators.minLength(ERROR_HANDLING.PASSWORD_MIN_LENGTH),
                this.customValidator.hasNumberValidator(),
            ]),
        });
    }
    get f() {
        return this.formLogin.controls;
    }
    async onFormSubmit() {
        this.formLoginSubmitted = true;
        this.formError = undefined;
        this.loading = true;
        if (this.formLogin.valid) {
            const email = this.formLogin.get('email')?.value;
            const password = this.formLogin.get('password')?.value;
            const { res, err } = await this.authService.emailPasswordSignIn(email, password);
            if (err) {
                this.formLoginSubmitted = this.loading = false;
                this.captchaRef?.reset();
                this.formError = err.errorData.title;
                return;
            }
            const token = await res?.user?.getIdToken(true);
            this.onSubmit.emit(token);
        }
        else {
            this.loading = false;
            this.formLogin.updateValueAndValidity();
            Validation.validateAll(this.formLogin);
        }
    }
    /**
     *
     *
     * @param {*} recaptchaKey
     * @memberof LoginComponent
     */
    resolved(recaptchaKey) {
        // null check prevents double-firing when recaptcha is reset
        if (recaptchaKey)
            this.onFormSubmit();
    }
    errored($event) {
        this.captchaRef?.reset();
    }
    onSubmitForm() {
        this.captchaRef.execute();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: LoginComponent, deps: [{ token: i1.FormBuilder }, { token: IAuthService }, { token: FormCustomValidationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: LoginComponent, selector: "auth-login", outputs: { onForgottenPassword: "onForgottenPassword", onSubmit: "onSubmit", onError: "onError" }, viewQueries: [{ propertyName: "captchaRef", first: true, predicate: ["captchaRef"], descendants: true }], ngImport: i0, template: "<form class=\"\" [formGroup]=\"formLogin\" (ngSubmit)=\"onSubmitForm()\" novalidate>\n  <div>\n    <e11-input\n      [type]=\"'email'\"\n      name=\"email\"\n      id=\"email_formLogin_body\"\n      label=\"{{ 'Email' | translate }}\"\n      [size]=\"'md'\"\n      [borderGlow]=\"'primary'\"\n      [parentForm]=\"formLogin\"\n      [autofocus]=\"false\"\n      formControlName=\"email\"\n      [hasError]=\"(f.email.errors && f.email.dirty) || (f.email.invalid && formLoginSubmitted)\"\n    >\n      <e11-input-errors [parentForm]=\"formLogin\" [formControl]=\"f.email\" label=\"{{ 'Email' | translate }}\"></e11-input-errors>\n    </e11-input>\n  </div>\n\n  <ng-container>\n    <e11-input\n      [type]=\"'password'\"\n      name=\"password\"\n      id=\"password_formLogin_body\"\n      label=\"{{ 'Password' | translate }}\"\n      [parentForm]=\"formLogin\"\n      [autofocus]=\"false\"\n      formControlName=\"password\"\n      [togglePassword]=\"true\"\n      [hasError]=\"(f.password.errors && f.password.dirty) || (f.password.invalid && formLoginSubmitted)\"\n    >\n      <e11-input-errors [parentForm]=\"formLogin\" [formControl]=\"f.password\" label=\"{{ 'Password' | translate }}\"></e11-input-errors>\n    </e11-input>\n  </ng-container>\n\n  <div *ngIf=\"formError\">\n    <p class=\"e11-text-sm e11-text-skin-error\">\n      {{ formError | translate }}\n    </p>\n  </div>\n\n  <div class=\"\">\n    <e11-button\n      [color]=\"'primary-accent'\"\n      [type]=\"'submit'\"\n      value=\"{{ loading ? 'Signing in' : ('Sign in' | translate) }}\"\n      [disabled]=\"loading\"\n      [display]=\"'block'\"\n    >\n    </e11-button>\n    <div class=\"e11-w-full e11-mt-2 e11-text-right\">\n      <a class=\"e11-text-sm e11-text-skin-primary-accent hover:e11-text-skin-primary e11-cursor-pointer\" (click)=\"onForgottenPassword.emit(true)\">\n        {{ \"Forgot your password?\" | translate }}\n      </a>\n    </div>\n  </div>\n  <re-captcha #captchaRef=\"reCaptcha\" size=\"invisible\" (resolved)=\"resolved($event)\" (error)=\"errored($event)\" errorMode=\"handled\"></re-captcha>\n</form>\n", styles: [""], dependencies: [{ kind: "directive", type: i4$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i5$1.RecaptchaComponent, selector: "re-captcha", inputs: ["id", "siteKey", "theme", "type", "size", "tabIndex", "badge", "errorMode"], outputs: ["resolved", "error", "errored"], exportAs: ["reCaptcha"] }, { kind: "component", type: i6.E11InputComponent, selector: "e11-input", inputs: ["containerClass", "inputClass", "hintText", "label", "type", "size", "style", "placeholder", "maxLength", "max", "name", "id", "iconLeft", "iconLeftBorder", "required", "hasError", "labelColor", "borderGlow", "checkIcon", "clearIcon", "autofocus", "togglePassword", "hasButton", "buttonText", "buttonIcon", "buttonIconType", "buttonIconSize", "readonly", "disabled", "disabledText", "autocomplete", "formControlName", "isRounded", "parentForm", "tooltipConfig", "icon", "iconType", "iconSize", "darkMode", "context", "enforceCharacterLimit", "showCharacterLimitWarning", "loading", "leadingIcon", "trailingIcon"], outputs: ["change", "focus", "blur"] }, { kind: "component", type: i7.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i8.E11InputErrorsComponent, selector: "e11-input-errors", inputs: ["formControl", "parentForm", "label", "formSubmitted", "suppressError", "messageOverrides"] }, { kind: "pipe", type: i9.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: LoginComponent, decorators: [{
            type: Component,
            args: [{ selector: 'auth-login', encapsulation: ViewEncapsulation.None, template: "<form class=\"\" [formGroup]=\"formLogin\" (ngSubmit)=\"onSubmitForm()\" novalidate>\n  <div>\n    <e11-input\n      [type]=\"'email'\"\n      name=\"email\"\n      id=\"email_formLogin_body\"\n      label=\"{{ 'Email' | translate }}\"\n      [size]=\"'md'\"\n      [borderGlow]=\"'primary'\"\n      [parentForm]=\"formLogin\"\n      [autofocus]=\"false\"\n      formControlName=\"email\"\n      [hasError]=\"(f.email.errors && f.email.dirty) || (f.email.invalid && formLoginSubmitted)\"\n    >\n      <e11-input-errors [parentForm]=\"formLogin\" [formControl]=\"f.email\" label=\"{{ 'Email' | translate }}\"></e11-input-errors>\n    </e11-input>\n  </div>\n\n  <ng-container>\n    <e11-input\n      [type]=\"'password'\"\n      name=\"password\"\n      id=\"password_formLogin_body\"\n      label=\"{{ 'Password' | translate }}\"\n      [parentForm]=\"formLogin\"\n      [autofocus]=\"false\"\n      formControlName=\"password\"\n      [togglePassword]=\"true\"\n      [hasError]=\"(f.password.errors && f.password.dirty) || (f.password.invalid && formLoginSubmitted)\"\n    >\n      <e11-input-errors [parentForm]=\"formLogin\" [formControl]=\"f.password\" label=\"{{ 'Password' | translate }}\"></e11-input-errors>\n    </e11-input>\n  </ng-container>\n\n  <div *ngIf=\"formError\">\n    <p class=\"e11-text-sm e11-text-skin-error\">\n      {{ formError | translate }}\n    </p>\n  </div>\n\n  <div class=\"\">\n    <e11-button\n      [color]=\"'primary-accent'\"\n      [type]=\"'submit'\"\n      value=\"{{ loading ? 'Signing in' : ('Sign in' | translate) }}\"\n      [disabled]=\"loading\"\n      [display]=\"'block'\"\n    >\n    </e11-button>\n    <div class=\"e11-w-full e11-mt-2 e11-text-right\">\n      <a class=\"e11-text-sm e11-text-skin-primary-accent hover:e11-text-skin-primary e11-cursor-pointer\" (click)=\"onForgottenPassword.emit(true)\">\n        {{ \"Forgot your password?\" | translate }}\n      </a>\n    </div>\n  </div>\n  <re-captcha #captchaRef=\"reCaptcha\" size=\"invisible\" (resolved)=\"resolved($event)\" (error)=\"errored($event)\" errorMode=\"handled\"></re-captcha>\n</form>\n" }]
        }], ctorParameters: () => [{ type: i1.FormBuilder }, { type: IAuthService }, { type: FormCustomValidationService }], propDecorators: { captchaRef: [{
                type: ViewChild,
                args: ['captchaRef']
            }], onForgottenPassword: [{
                type: Output
            }], onSubmit: [{
                type: Output
            }], onError: [{
                type: Output
            }] } });

class AccountManagePasswordComponent {
    constructor(formBuilder, customValidator, authService, notificationsService) {
        this.formBuilder = formBuilder;
        this.customValidator = customValidator;
        this.authService = authService;
        this.notificationsService = notificationsService;
        // Forms:
        this.formSecurity = new FormGroup({}); // ! Do NOT type new forms as "any" - this is from the Angular 14 migration
        this.formSecuritySubmitted = false;
        // error handling
        this.passwordMinLength = { value: ERROR_HANDLING.PASSWORD_MIN_LENGTH };
        this.loading = false;
    }
    ngOnInit() {
        this.formSecurity = this.formBuilder.group({
            password: new FormControl('', [
                Validators.required,
                Validators.minLength(ERROR_HANDLING.PASSWORD_MIN_LENGTH),
                this.customValidator.hasNumberValidator(),
            ]),
            passwordNew: new FormControl('', [
                Validators.required,
                Validators.minLength(ERROR_HANDLING.PASSWORD_MIN_LENGTH),
                this.customValidator.hasNumberValidator(),
            ]),
            passwordConfirm: new FormControl('', [Validators.required]),
        }, {
            validator: [this.customValidator.passwordMatch('passwordNew', 'passwordConfirm')],
        });
    }
    get f() {
        return this.formSecurity.controls;
    }
    async onSubmitFormSecurity() {
        this.loading = true;
        this.formError = undefined;
        let { err } = await this.authService.updatePassword(this.formSecurity.value.password, this.formSecurity.value.passwordNew);
        if (err) {
            this.loading = false;
            this.formError = this.getErrorMessage(err.errorData);
            return;
        }
        const notification = new E11NotificationMessage('Success!', 'Your new password has been saved.', 'success', false, 'Close');
        this.notificationsService.popNotificationMessage(notification);
        this.formSecurity.reset();
        this.loading = false;
    }
    getErrorMessage(e11ErrorData) {
        switch (e11ErrorData.type) {
            case AUTH_ERRORS.WRONG_PASSWORD:
                return 'Your current password is incorrect. Please try again.';
            case AUTH_ERRORS.TOO_MANY_REQUESTS:
                return 'You have made too many incorrect attempts. Please try again later.';
            default:
                return e11ErrorData.title;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: AccountManagePasswordComponent, deps: [{ token: i1.FormBuilder }, { token: FormCustomValidationService }, { token: IAuthService }, { token: i5.E11NotificationsService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: AccountManagePasswordComponent, selector: "sdk-auth-manage-password", ngImport: i0, template: "<form class=\"password-form\" [formGroup]=\"formSecurity\" (ngSubmit)=\"onSubmitFormSecurity()\" novalidate>\n  <e11-input\n    [type]=\"'password'\"\n    name=\"password\"\n    id=\"password_formSecurity\"\n    label=\"{{ 'Current Password' | translate }}\"\n    [size]=\"'md'\"\n    [parentForm]=\"formSecurity\"\n    [autofocus]=\"false\"\n    formControlName=\"password\"\n    autocomplete=\"off\"\n    [togglePassword]=\"true\"\n    borderGlow=\"primary\"\n    [required]=\"true\"\n    [hasError]=\"f.password.hasError('minlength') || f.password.hasError('hasNumberError') || (f.password.invalid && formSecuritySubmitted)\"\n  >\n    <e11-input-errors [parentForm]=\"formSecurity\" [formControl]=\"f.password\" label=\"{{ 'Password' | translate }}\"> </e11-input-errors>\n  </e11-input>\n\n  <!-- PasswordCurrentIncorrect -->\n\n  <e11-input\n    [type]=\"'password'\"\n    name=\"passwordNew\"\n    id=\"passwordNew_formSecurity\"\n    label=\"{{ 'New Password' | translate }}\"\n    [size]=\"'md'\"\n    [parentForm]=\"formSecurity\"\n    [autofocus]=\"false\"\n    formControlName=\"passwordNew\"\n    autocomplete=\"off\"\n    [togglePassword]=\"true\"\n    borderGlow=\"primary\"\n    [required]=\"true\"\n    [hasError]=\"f.passwordNew.hasError('minlength') || f.passwordNew.hasError('hasNumberError') || (f.passwordNew.invalid && formSecuritySubmitted)\"\n  >\n    <e11-input-errors [parentForm]=\"formSecurity\" [formControl]=\"f.passwordNew\" label=\"{{ 'Password' | translate }}\"> </e11-input-errors>\n  </e11-input>\n\n  <e11-input\n    [type]=\"'password'\"\n    name=\"passwordConfirm\"\n    id=\"passwordConfirm_formSecurity\"\n    label=\"{{ 'Re-enter New Password' | translate }}\"\n    [size]=\"'md'\"\n    [parentForm]=\"formSecurity\"\n    [autofocus]=\"false\"\n    formControlName=\"passwordConfirm\"\n    autocomplete=\"off\"\n    [togglePassword]=\"true\"\n    borderGlow=\"primary\"\n    [required]=\"true\"\n    [hasError]=\"f.passwordNew.hasError('passwordMatchError') || (f.passwordNew.invalid && formSecuritySubmitted)\"\n  >\n    <e11-input-errors [parentForm]=\"formSecurity\" [formControl]=\"f.passwordConfirm\" label=\"{{ 'Confirm Password' | translate }}\"> </e11-input-errors>\n  </e11-input>\n\n  <div class=\"e11-my-8\"></div>\n\n  <div class=\"error-message-password-list\">\n    <span class=\"error-message\">\n      {{ \"Your password must meet the following requirements:\" | translate }}\n    </span>\n    <span\n      class=\"error-message\"\n      [ngClass]=\"{\n        'e11-text-skin-error': f.passwordNew.hasError('minlength') || (formSecuritySubmitted && f.passwordNew.invalid),\n        'pass e11-text-skin-success': !f.passwordNew.hasError('minlength') && f.passwordNew.dirty && f.passwordNew.value.length > 0\n      }\"\n    >\n      {{ \"Minimum length is 8 characters\" | translate }} <i class=\"fas fa-check\"></i\n    ></span>\n    <span\n      class=\"error-message\"\n      [ngClass]=\"{\n        'e11-text-skin-error': f.passwordNew.hasError('hasNumberError') || (formSecuritySubmitted && f.passwordNew.invalid),\n        'pass e11-text-skin-success': !f.passwordNew.hasError('hasNumberError') && f.passwordNew.dirty && f.passwordNew.value.length > 0\n      }\"\n      >{{ \"Include 1 number\" | translate }} <i class=\"fas fa-check\"></i\n    ></span>\n  </div>\n\n  <span class=\"error\" *ngIf=\"formError\">\n    <div class=\"e11-my-8\"></div>\n    <span class=\"error-message e11-text-skin-error\">{{ formError | translate }}</span>\n  </span>\n  <div class=\"e11-my-8\"></div>\n\n  <div class=\"e11-text-center\">\n    <e11-button\n      id=\"submit_security\"\n      value=\"{{ loading ? 'Loading...' : ('Save' | translate) }}\"\n      color=\"primary-accent\"\n      [type]=\"'submit'\"\n      [icon]=\"'save'\"\n      [iconPosition]=\"'left'\"\n      [iconSize]=\"'md-18'\"\n      [disabled]=\"formSecurity.invalid || loading\"\n    >\n    </e11-button>\n  </div>\n</form>\n", styles: [".error-message-password-list{position:relative;margin-top:-1.5rem;margin-bottom:1rem}.error-message-password-list .error-message{display:block;line-height:1.5rem}.error-message-password-list .error-message i{margin-left:5px;opacity:0;transition:opacity .4s ease-in-out 0s}.error-message-password-list .error-message.pass i{opacity:1;transition:opacity .4s ease-in-out 0s}\n"], dependencies: [{ kind: "directive", type: i4$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i6.E11InputComponent, selector: "e11-input", inputs: ["containerClass", "inputClass", "hintText", "label", "type", "size", "style", "placeholder", "maxLength", "max", "name", "id", "iconLeft", "iconLeftBorder", "required", "hasError", "labelColor", "borderGlow", "checkIcon", "clearIcon", "autofocus", "togglePassword", "hasButton", "buttonText", "buttonIcon", "buttonIconType", "buttonIconSize", "readonly", "disabled", "disabledText", "autocomplete", "formControlName", "isRounded", "parentForm", "tooltipConfig", "icon", "iconType", "iconSize", "darkMode", "context", "enforceCharacterLimit", "showCharacterLimitWarning", "loading", "leadingIcon", "trailingIcon"], outputs: ["change", "focus", "blur"] }, { kind: "component", type: i7.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i8.E11InputErrorsComponent, selector: "e11-input-errors", inputs: ["formControl", "parentForm", "label", "formSubmitted", "suppressError", "messageOverrides"] }, { kind: "pipe", type: i9.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: AccountManagePasswordComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-auth-manage-password', template: "<form class=\"password-form\" [formGroup]=\"formSecurity\" (ngSubmit)=\"onSubmitFormSecurity()\" novalidate>\n  <e11-input\n    [type]=\"'password'\"\n    name=\"password\"\n    id=\"password_formSecurity\"\n    label=\"{{ 'Current Password' | translate }}\"\n    [size]=\"'md'\"\n    [parentForm]=\"formSecurity\"\n    [autofocus]=\"false\"\n    formControlName=\"password\"\n    autocomplete=\"off\"\n    [togglePassword]=\"true\"\n    borderGlow=\"primary\"\n    [required]=\"true\"\n    [hasError]=\"f.password.hasError('minlength') || f.password.hasError('hasNumberError') || (f.password.invalid && formSecuritySubmitted)\"\n  >\n    <e11-input-errors [parentForm]=\"formSecurity\" [formControl]=\"f.password\" label=\"{{ 'Password' | translate }}\"> </e11-input-errors>\n  </e11-input>\n\n  <!-- PasswordCurrentIncorrect -->\n\n  <e11-input\n    [type]=\"'password'\"\n    name=\"passwordNew\"\n    id=\"passwordNew_formSecurity\"\n    label=\"{{ 'New Password' | translate }}\"\n    [size]=\"'md'\"\n    [parentForm]=\"formSecurity\"\n    [autofocus]=\"false\"\n    formControlName=\"passwordNew\"\n    autocomplete=\"off\"\n    [togglePassword]=\"true\"\n    borderGlow=\"primary\"\n    [required]=\"true\"\n    [hasError]=\"f.passwordNew.hasError('minlength') || f.passwordNew.hasError('hasNumberError') || (f.passwordNew.invalid && formSecuritySubmitted)\"\n  >\n    <e11-input-errors [parentForm]=\"formSecurity\" [formControl]=\"f.passwordNew\" label=\"{{ 'Password' | translate }}\"> </e11-input-errors>\n  </e11-input>\n\n  <e11-input\n    [type]=\"'password'\"\n    name=\"passwordConfirm\"\n    id=\"passwordConfirm_formSecurity\"\n    label=\"{{ 'Re-enter New Password' | translate }}\"\n    [size]=\"'md'\"\n    [parentForm]=\"formSecurity\"\n    [autofocus]=\"false\"\n    formControlName=\"passwordConfirm\"\n    autocomplete=\"off\"\n    [togglePassword]=\"true\"\n    borderGlow=\"primary\"\n    [required]=\"true\"\n    [hasError]=\"f.passwordNew.hasError('passwordMatchError') || (f.passwordNew.invalid && formSecuritySubmitted)\"\n  >\n    <e11-input-errors [parentForm]=\"formSecurity\" [formControl]=\"f.passwordConfirm\" label=\"{{ 'Confirm Password' | translate }}\"> </e11-input-errors>\n  </e11-input>\n\n  <div class=\"e11-my-8\"></div>\n\n  <div class=\"error-message-password-list\">\n    <span class=\"error-message\">\n      {{ \"Your password must meet the following requirements:\" | translate }}\n    </span>\n    <span\n      class=\"error-message\"\n      [ngClass]=\"{\n        'e11-text-skin-error': f.passwordNew.hasError('minlength') || (formSecuritySubmitted && f.passwordNew.invalid),\n        'pass e11-text-skin-success': !f.passwordNew.hasError('minlength') && f.passwordNew.dirty && f.passwordNew.value.length > 0\n      }\"\n    >\n      {{ \"Minimum length is 8 characters\" | translate }} <i class=\"fas fa-check\"></i\n    ></span>\n    <span\n      class=\"error-message\"\n      [ngClass]=\"{\n        'e11-text-skin-error': f.passwordNew.hasError('hasNumberError') || (formSecuritySubmitted && f.passwordNew.invalid),\n        'pass e11-text-skin-success': !f.passwordNew.hasError('hasNumberError') && f.passwordNew.dirty && f.passwordNew.value.length > 0\n      }\"\n      >{{ \"Include 1 number\" | translate }} <i class=\"fas fa-check\"></i\n    ></span>\n  </div>\n\n  <span class=\"error\" *ngIf=\"formError\">\n    <div class=\"e11-my-8\"></div>\n    <span class=\"error-message e11-text-skin-error\">{{ formError | translate }}</span>\n  </span>\n  <div class=\"e11-my-8\"></div>\n\n  <div class=\"e11-text-center\">\n    <e11-button\n      id=\"submit_security\"\n      value=\"{{ loading ? 'Loading...' : ('Save' | translate) }}\"\n      color=\"primary-accent\"\n      [type]=\"'submit'\"\n      [icon]=\"'save'\"\n      [iconPosition]=\"'left'\"\n      [iconSize]=\"'md-18'\"\n      [disabled]=\"formSecurity.invalid || loading\"\n    >\n    </e11-button>\n  </div>\n</form>\n", styles: [".error-message-password-list{position:relative;margin-top:-1.5rem;margin-bottom:1rem}.error-message-password-list .error-message{display:block;line-height:1.5rem}.error-message-password-list .error-message i{margin-left:5px;opacity:0;transition:opacity .4s ease-in-out 0s}.error-message-password-list .error-message.pass i{opacity:1;transition:opacity .4s ease-in-out 0s}\n"] }]
        }], ctorParameters: () => [{ type: i1.FormBuilder }, { type: FormCustomValidationService }, { type: IAuthService }, { type: i5.E11NotificationsService }] });

class PasswordResetComponent {
    constructor(formBuilder, authService, customValidator) {
        this.formBuilder = formBuilder;
        this.authService = authService;
        this.customValidator = customValidator;
        this.formPassword = new FormGroup({}); // ! Do NOT type new forms as "any" - this is from the Angular 14 migration
        this.formPasswordSubmitted = false;
        this.loading = false;
        this.passwordMinLength = { value: ERROR_HANDLING.PASSWORD_MIN_LENGTH };
        this.onSubmit = new EventEmitter();
        this.onError = new EventEmitter();
    }
    ngOnInit() {
        this.formPassword = this.formBuilder.group({
            password: new FormControl('', [
                Validators.required,
                Validators.minLength(ERROR_HANDLING.PASSWORD_MIN_LENGTH),
                this.customValidator.hasNumberValidator(),
            ]),
            passwordConfirm: new FormControl('', [Validators.required]),
        }, {
            validator: [this.customValidator.passwordMatch('password', 'passwordConfirm')],
        });
    }
    /**
     *
     * Shortcut to form controls
     * @readonly
     * @memberof LoginComponent
     */
    get fc() {
        return this.formPassword.controls;
    }
    async onFormSubmit() {
        this.formPasswordSubmitted = true;
        this.formError = undefined;
        this.loading = true;
        if (this.formPassword.valid && this.actionCode) {
            const password = this.formPassword.get('password')?.value;
            const { res, err } = await this.authService.handleResetPassword(password, this.actionCode);
            if (err) {
                this.formError = this.getErrorMessage(err.errorData);
                this.onError.emit(err);
                this.loading = false;
                return;
            }
            const result = {
                email: res,
                password: password,
            };
            this.onSubmit.emit(JSON.stringify(result));
        }
        else {
            this.loading = false;
        }
    }
    async resolved($event) {
        if ($event)
            await this.onFormSubmit();
    }
    errored($event) {
        this.captchaRef?.reset();
    }
    getErrorMessage(e11ErrorData) {
        switch (e11ErrorData.type) {
            case AUTH_ERRORS.EXPIRED_ACTION_CODE:
                return 'This password reset link has expired. Please try again with a new link.';
            case AUTH_ERRORS.INVALID_ACTION_CODE:
                return 'This password reset link is invalid. Please try again with a new link.';
            default:
                return e11ErrorData.title;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PasswordResetComponent, deps: [{ token: i1.FormBuilder }, { token: IAuthService }, { token: FormCustomValidationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: PasswordResetComponent, selector: "auth-password-reset", inputs: { actionCode: "actionCode" }, outputs: { onSubmit: "onSubmit", onError: "onError" }, viewQueries: [{ propertyName: "captchaRef", first: true, predicate: ["captchaRef"], descendants: true }], ngImport: i0, template: "<form class=\"\" [formGroup]=\"formPassword\" (ngSubmit)=\"captchaRef.execute()\" novalidate>\n  <div>\n    <e11-input\n      [type]=\"'password'\"\n      name=\"password\"\n      id=\"password_formPassword\"\n      label=\"{{ 'Password' | translate }}\"\n      [parentForm]=\"formPassword\"\n      [autofocus]=\"false\"\n      formControlName=\"password\"\n      autocomplete=\"off\"\n      [togglePassword]=\"true\"\n      [hasError]=\"fc.password.hasError('minlength') || fc.password.hasError('hasNumberError') || (fc.password.invalid && formPasswordSubmitted)\"\n    >\n      <e11-input-errors [parentForm]=\"formPassword\" [formControl]=\"fc.password\" label=\"{{ 'Password' | translate }}\"></e11-input-errors>\n    </e11-input>\n  </div>\n\n  <ng-container>\n    <e11-input\n      [type]=\"'password'\"\n      name=\"passwordConfirm\"\n      id=\"passwordConfirm_formPassword\"\n      label=\"{{ 'Re-enter Password' | translate }}\"\n      [parentForm]=\"formPassword\"\n      [autofocus]=\"false\"\n      formControlName=\"passwordConfirm\"\n      autocomplete=\"off\"\n      [togglePassword]=\"true\"\n      [hasError]=\"(fc.passwordConfirm.errors && fc.passwordConfirm.dirty) || (fc.passwordConfirm.invalid && formPasswordSubmitted)\"\n    >\n      <e11-input-errors [parentForm]=\"formPassword\" [formControl]=\"fc.passwordConfirm\" label=\"{{ 'Email' | translate }}\"></e11-input-errors>\n    </e11-input>\n  </ng-container>\n  <p *ngIf=\"formError\" class=\"e11-text-sm e11-text-skin-error\">\n    {{ formError | translate }}\n  </p>\n\n  <div class=\"e11-w-full e11-mb-4\">\n    <p class=\"error-message e11-mb-0\">\n      {{ \"ErrorHandling.PasswordRequirements\" | translate }}\n    </p>\n    <div class=\"e11-ml-2 e11-flex-col\">\n      <div\n        class=\"e11-text-sm e11-items-center\"\n        [ngClass]=\"{\n          'e11-text-skin-error': fc.password.hasError('minlength') || (formPasswordSubmitted && fc.password.invalid),\n          'e11-text-skin-success': !fc.password.hasError('minlength') && fc.password.dirty && fc.password.value.length > 0\n        }\"\n      >\n        {{ \"ErrorHandling.MinCharacterLength\" | translate: passwordMinLength }}\n        <svg\n          *ngIf=\"!fc.password.hasError('minlength') && fc.password.dirty && fc.password.value.length > 0\"\n          class=\"e11-inline-flex e11-h-4 e11-w-4 e11-text-skin-success e11-ml-2\"\n          xmlns=\"http://www.w3.org/2000/svg\"\n          viewBox=\"0 0 20 20\"\n          fill=\"currentColor\"\n          aria-hidden=\"true\"\n        >\n          <path\n            fill-rule=\"evenodd\"\n            d=\"M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z\"\n            clip-rule=\"evenodd\"\n          />\n        </svg>\n      </div>\n      <div\n        class=\"e11-text-sm e11-items-center\"\n        [ngClass]=\"{\n          'e11-text-skin-error': fc.password.hasError('hasNumberError') || (formPasswordSubmitted && fc.password.invalid),\n          'e11-text-skin-success': !fc.password.hasError('hasNumberError') && fc.password.dirty && fc.password.value.length > 0\n        }\"\n      >\n        {{ \"ErrorHandling.PasswordMustIncludeNumber\" | translate }}\n        <svg\n          *ngIf=\"!fc.password.hasError('hasNumberError') && fc.password.dirty && fc.password.value.length > 0\"\n          class=\"e11-inline-flex e11-h-4 e11-w-4 e11-text-skin-success e11-ml-2\"\n          xmlns=\"http://www.w3.org/2000/svg\"\n          viewBox=\"0 0 20 20\"\n          fill=\"currentColor\"\n          aria-hidden=\"true\"\n        >\n          <path\n            fill-rule=\"evenodd\"\n            d=\"M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z\"\n            clip-rule=\"evenodd\"\n          />\n        </svg>\n      </div>\n    </div>\n  </div>\n  <div class=\"\">\n    <e11-button [color]=\"'primary-accent'\" [type]=\"'submit'\" value=\"{{ loading ? 'Loading...' : ('Submit' | translate) }}\" [display]=\"'block'\">\n    </e11-button>\n  </div>\n  <re-captcha #captchaRef=\"reCaptcha\" size=\"invisible\" (resolved)=\"resolved($event)\" (error)=\"errored($event)\" errorMode=\"handled\"></re-captcha>\n</form>\n", styles: [""], dependencies: [{ kind: "directive", type: i4$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i5$1.RecaptchaComponent, selector: "re-captcha", inputs: ["id", "siteKey", "theme", "type", "size", "tabIndex", "badge", "errorMode"], outputs: ["resolved", "error", "errored"], exportAs: ["reCaptcha"] }, { kind: "component", type: i6.E11InputComponent, selector: "e11-input", inputs: ["containerClass", "inputClass", "hintText", "label", "type", "size", "style", "placeholder", "maxLength", "max", "name", "id", "iconLeft", "iconLeftBorder", "required", "hasError", "labelColor", "borderGlow", "checkIcon", "clearIcon", "autofocus", "togglePassword", "hasButton", "buttonText", "buttonIcon", "buttonIconType", "buttonIconSize", "readonly", "disabled", "disabledText", "autocomplete", "formControlName", "isRounded", "parentForm", "tooltipConfig", "icon", "iconType", "iconSize", "darkMode", "context", "enforceCharacterLimit", "showCharacterLimitWarning", "loading", "leadingIcon", "trailingIcon"], outputs: ["change", "focus", "blur"] }, { kind: "component", type: i7.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i8.E11InputErrorsComponent, selector: "e11-input-errors", inputs: ["formControl", "parentForm", "label", "formSubmitted", "suppressError", "messageOverrides"] }, { kind: "pipe", type: i9.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PasswordResetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'auth-password-reset', template: "<form class=\"\" [formGroup]=\"formPassword\" (ngSubmit)=\"captchaRef.execute()\" novalidate>\n  <div>\n    <e11-input\n      [type]=\"'password'\"\n      name=\"password\"\n      id=\"password_formPassword\"\n      label=\"{{ 'Password' | translate }}\"\n      [parentForm]=\"formPassword\"\n      [autofocus]=\"false\"\n      formControlName=\"password\"\n      autocomplete=\"off\"\n      [togglePassword]=\"true\"\n      [hasError]=\"fc.password.hasError('minlength') || fc.password.hasError('hasNumberError') || (fc.password.invalid && formPasswordSubmitted)\"\n    >\n      <e11-input-errors [parentForm]=\"formPassword\" [formControl]=\"fc.password\" label=\"{{ 'Password' | translate }}\"></e11-input-errors>\n    </e11-input>\n  </div>\n\n  <ng-container>\n    <e11-input\n      [type]=\"'password'\"\n      name=\"passwordConfirm\"\n      id=\"passwordConfirm_formPassword\"\n      label=\"{{ 'Re-enter Password' | translate }}\"\n      [parentForm]=\"formPassword\"\n      [autofocus]=\"false\"\n      formControlName=\"passwordConfirm\"\n      autocomplete=\"off\"\n      [togglePassword]=\"true\"\n      [hasError]=\"(fc.passwordConfirm.errors && fc.passwordConfirm.dirty) || (fc.passwordConfirm.invalid && formPasswordSubmitted)\"\n    >\n      <e11-input-errors [parentForm]=\"formPassword\" [formControl]=\"fc.passwordConfirm\" label=\"{{ 'Email' | translate }}\"></e11-input-errors>\n    </e11-input>\n  </ng-container>\n  <p *ngIf=\"formError\" class=\"e11-text-sm e11-text-skin-error\">\n    {{ formError | translate }}\n  </p>\n\n  <div class=\"e11-w-full e11-mb-4\">\n    <p class=\"error-message e11-mb-0\">\n      {{ \"ErrorHandling.PasswordRequirements\" | translate }}\n    </p>\n    <div class=\"e11-ml-2 e11-flex-col\">\n      <div\n        class=\"e11-text-sm e11-items-center\"\n        [ngClass]=\"{\n          'e11-text-skin-error': fc.password.hasError('minlength') || (formPasswordSubmitted && fc.password.invalid),\n          'e11-text-skin-success': !fc.password.hasError('minlength') && fc.password.dirty && fc.password.value.length > 0\n        }\"\n      >\n        {{ \"ErrorHandling.MinCharacterLength\" | translate: passwordMinLength }}\n        <svg\n          *ngIf=\"!fc.password.hasError('minlength') && fc.password.dirty && fc.password.value.length > 0\"\n          class=\"e11-inline-flex e11-h-4 e11-w-4 e11-text-skin-success e11-ml-2\"\n          xmlns=\"http://www.w3.org/2000/svg\"\n          viewBox=\"0 0 20 20\"\n          fill=\"currentColor\"\n          aria-hidden=\"true\"\n        >\n          <path\n            fill-rule=\"evenodd\"\n            d=\"M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z\"\n            clip-rule=\"evenodd\"\n          />\n        </svg>\n      </div>\n      <div\n        class=\"e11-text-sm e11-items-center\"\n        [ngClass]=\"{\n          'e11-text-skin-error': fc.password.hasError('hasNumberError') || (formPasswordSubmitted && fc.password.invalid),\n          'e11-text-skin-success': !fc.password.hasError('hasNumberError') && fc.password.dirty && fc.password.value.length > 0\n        }\"\n      >\n        {{ \"ErrorHandling.PasswordMustIncludeNumber\" | translate }}\n        <svg\n          *ngIf=\"!fc.password.hasError('hasNumberError') && fc.password.dirty && fc.password.value.length > 0\"\n          class=\"e11-inline-flex e11-h-4 e11-w-4 e11-text-skin-success e11-ml-2\"\n          xmlns=\"http://www.w3.org/2000/svg\"\n          viewBox=\"0 0 20 20\"\n          fill=\"currentColor\"\n          aria-hidden=\"true\"\n        >\n          <path\n            fill-rule=\"evenodd\"\n            d=\"M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z\"\n            clip-rule=\"evenodd\"\n          />\n        </svg>\n      </div>\n    </div>\n  </div>\n  <div class=\"\">\n    <e11-button [color]=\"'primary-accent'\" [type]=\"'submit'\" value=\"{{ loading ? 'Loading...' : ('Submit' | translate) }}\" [display]=\"'block'\">\n    </e11-button>\n  </div>\n  <re-captcha #captchaRef=\"reCaptcha\" size=\"invisible\" (resolved)=\"resolved($event)\" (error)=\"errored($event)\" errorMode=\"handled\"></re-captcha>\n</form>\n" }]
        }], ctorParameters: () => [{ type: i1.FormBuilder }, { type: IAuthService }, { type: FormCustomValidationService }], propDecorators: { captchaRef: [{
                type: ViewChild,
                args: ['captchaRef']
            }], actionCode: [{
                type: Input
            }], onSubmit: [{
                type: Output
            }], onError: [{
                type: Output
            }] } });

const TIME_BETWEEN_RESEND = 120;
class VerificationComponent {
    constructor(authService, authRestService, errorHandler) {
        this.authService = authService;
        this.authRestService = authRestService;
        this.errorHandler = errorHandler;
        this.param = { value: '' };
        this.onResend = new EventEmitter();
        this.subs = new Array();
        this.resendTimeLeft = 0;
        this.loading = false;
        this.subs[0] = this.authService.user$.pipe(filter(isNotNil)).subscribe((user) => {
            this.param = { value: user?.email };
        });
    }
    ngOnInit() { }
    ngOnDestroy() {
        this.subs.forEach((s) => s.unsubscribe());
    }
    /**
     *
     *
     * @returns {Promise<void>}
     * @memberof VerificationComponent
     */
    resendEmail() {
        this.setResendTimer();
        const email = this.param.value;
        return this.authRestService.resendVerificationEmail(email);
    }
    signOut() {
        return this.authService.signOut();
    }
    setResendTimer() {
        this.resendTimeLeft = TIME_BETWEEN_RESEND;
        const interval = setInterval(() => {
            if (this.resendTimeLeft > 0) {
                this.resendTimeLeft--;
            }
            else {
                clearInterval(interval);
            }
        }, 1000);
    }
    async onReload() {
        this.loading = true;
        this.subs[1] = this.authService.onIdTokenChange().subscribe((token) => {
            if (token) {
                this.loading = false;
                window.location.reload();
            }
        }, (err) => {
            this.loading = false;
            this.errorHandler.error(err);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: VerificationComponent, deps: [{ token: IAuthService }, { token: AuthRestService }, { token: i4.E11ErrorHandlerService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: VerificationComponent, selector: "auth-verification", outputs: { onResend: "onResend" }, ngImport: i0, template: "<div class=\"e11-w-full\">\n  <p *ngIf=\"param\" class=\"e11-text-center\">{{ \"Auth.Registration.WeSentAnEmailTo\" | translate: param }}</p>\n  <p *ngIf=\"!param\" class=\"e11-text-center\">{{ \"Auth.Registration.IfWeFindYourEmail\" | translate }}</p>\n  <div class=\"e11-py-4\"></div>\n  <p class=\"e11-text-center e11-text-sm\">\n    {{ \"Auth.Registration.DidntGetAnEmail\" | translate }}\n    <a *ngIf=\"resendTimeLeft === 0\" class=\"e11-text-skin-primary-accent\" href=\"javascript:void(0)\" (click)=\"resendEmail()\">\n      {{ \"Auth.Registration.ResendEmail\" | translate }}\n    </a>\n    <span *ngIf=\"resendTimeLeft > 0\">{{ \"Resend Email in \" + resendTimeLeft + \" seconds\" }}</span>\n  </p>\n</div>\n\n<div class=\"e11-mb-4\">\n  <e11-button\n    [color]=\"'primary-accent'\"\n    [type]=\"'button'\"\n    value=\"{{ loading ? 'Loading...' : ('Continue' | translate) }}\"\n    [display]=\"'block'\"\n    (click)=\"onReload()\"\n  >\n  </e11-button>\n</div>\n\n<p class=\"e11-text-center e11-text-sm\">\n  {{ \"Having problems?\" | translate }}\n  <a class=\"e11-text-skin-primary-accent\" href=\"javascript:void(0)\" (click)=\"signOut()\">\n    {{ \"Start Over With A Different Email\" | translate }}\n  </a>\n</p>\n", styles: [""], dependencies: [{ kind: "directive", type: i4$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i7.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "pipe", type: i9.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: VerificationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'auth-verification', template: "<div class=\"e11-w-full\">\n  <p *ngIf=\"param\" class=\"e11-text-center\">{{ \"Auth.Registration.WeSentAnEmailTo\" | translate: param }}</p>\n  <p *ngIf=\"!param\" class=\"e11-text-center\">{{ \"Auth.Registration.IfWeFindYourEmail\" | translate }}</p>\n  <div class=\"e11-py-4\"></div>\n  <p class=\"e11-text-center e11-text-sm\">\n    {{ \"Auth.Registration.DidntGetAnEmail\" | translate }}\n    <a *ngIf=\"resendTimeLeft === 0\" class=\"e11-text-skin-primary-accent\" href=\"javascript:void(0)\" (click)=\"resendEmail()\">\n      {{ \"Auth.Registration.ResendEmail\" | translate }}\n    </a>\n    <span *ngIf=\"resendTimeLeft > 0\">{{ \"Resend Email in \" + resendTimeLeft + \" seconds\" }}</span>\n  </p>\n</div>\n\n<div class=\"e11-mb-4\">\n  <e11-button\n    [color]=\"'primary-accent'\"\n    [type]=\"'button'\"\n    value=\"{{ loading ? 'Loading...' : ('Continue' | translate) }}\"\n    [display]=\"'block'\"\n    (click)=\"onReload()\"\n  >\n  </e11-button>\n</div>\n\n<p class=\"e11-text-center e11-text-sm\">\n  {{ \"Having problems?\" | translate }}\n  <a class=\"e11-text-skin-primary-accent\" href=\"javascript:void(0)\" (click)=\"signOut()\">\n    {{ \"Start Over With A Different Email\" | translate }}\n  </a>\n</p>\n" }]
        }], ctorParameters: () => [{ type: IAuthService }, { type: AuthRestService }, { type: i4.E11ErrorHandlerService }], propDecorators: { onResend: [{
                type: Output
            }] } });

class VerifyEmailComponent {
    constructor(authService) {
        this.authService = authService;
        this.loading = false;
        this.onSubmit = new EventEmitter();
    }
    async ngOnInit() {
        await this.verifyEmail();
    }
    async verifyEmail() {
        if (!this.actionCode) {
            this.errorMessage = 'No email verification code found. Please try again with a valid email verification link.';
            return;
        }
        this.loading = true;
        const { err } = await this.authService.handleVerifyEmail(this.actionCode);
        this.loading = false;
        if (err) {
            this.errorMessage = this.getErrorMessage(err.errorData);
            this.errorSubtitle = this.getErrorSubtitle(err.errorData);
            return;
        }
        this.onSubmit.emit();
    }
    getErrorMessage(e11ErrorData) {
        switch (e11ErrorData.type) {
            case AUTH_ERRORS.EXPIRED_ACTION_CODE:
                return 'This verification link has expired. Please try again with a new link.';
            case AUTH_ERRORS.INVALID_ACTION_CODE:
                return 'This verification link is invalid. Please try again with a new link.';
            default:
                return e11ErrorData.title;
        }
    }
    getErrorSubtitle(e11ErrorData) {
        switch (e11ErrorData.type) {
            case AUTH_ERRORS.EXPIRED_ACTION_CODE:
            case AUTH_ERRORS.INVALID_ACTION_CODE:
                return 'Please be sure to use the latest verification link you have received.';
            default:
                return undefined;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: VerifyEmailComponent, deps: [{ token: IAuthService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: VerifyEmailComponent, selector: "auth-verify-email", inputs: { actionCode: "actionCode" }, outputs: { onSubmit: "onSubmit" }, ngImport: i0, template: "<e11-loader-dots *ngIf=\"loading\" [size]=\"'md'\" [color]=\"'e11-bg-skin-primary-accent'\" [label]=\"'Verifying your email...'\"></e11-loader-dots>\n<div *ngIf=\"errorMessage\">\n  <div class=\"e11-block e11-text-center\">\n    <span class=\"material-icons md-48 e11-text-skin-error\"> report_problem </span>\n    <h1>{{ \"Oops!\" }}</h1>\n    <h3 class=\"e11-mb-2\">{{ \"We had an issue verifying your email.\" }}</h3>\n    <p class=\"e11-mb-0\">{{ errorMessage | translate }}</p>\n    <p *ngIf=\"errorSubtitle\">{{ errorSubtitle | translate }}</p>\n  </div>\n</div>\n", styles: [""], dependencies: [{ kind: "directive", type: i4$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3$1.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "pipe", type: i9.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: VerifyEmailComponent, decorators: [{
            type: Component,
            args: [{ selector: 'auth-verify-email', template: "<e11-loader-dots *ngIf=\"loading\" [size]=\"'md'\" [color]=\"'e11-bg-skin-primary-accent'\" [label]=\"'Verifying your email...'\"></e11-loader-dots>\n<div *ngIf=\"errorMessage\">\n  <div class=\"e11-block e11-text-center\">\n    <span class=\"material-icons md-48 e11-text-skin-error\"> report_problem </span>\n    <h1>{{ \"Oops!\" }}</h1>\n    <h3 class=\"e11-mb-2\">{{ \"We had an issue verifying your email.\" }}</h3>\n    <p class=\"e11-mb-0\">{{ errorMessage | translate }}</p>\n    <p *ngIf=\"errorSubtitle\">{{ errorSubtitle | translate }}</p>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: IAuthService }], propDecorators: { actionCode: [{
                type: Input
            }], onSubmit: [{
                type: Output
            }] } });

const ImportExportModules = [E11InputModule, E11ButtonModule, E11PanelModule, E11InputCheckboxModule, E11LoaderDotsModule];
const DeclareExportComponents = [
    AuthComponent,
    LoginComponent,
    VerificationComponent,
    PasswordResetComponent,
    VerifyEmailComponent,
    AccountManagePasswordComponent,
    ForgotPasswordComponent,
];
class AuthModule {
    static forRoot(rootConfig) {
        return {
            ngModule: AuthModule,
            providers: [
                AuthService,
                {
                    provide: BaseAuthConfigProvider,
                    useClass: rootConfig.configProvider,
                },
            ],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: AuthModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: AuthModule, declarations: [AuthComponent,
            LoginComponent,
            VerificationComponent,
            PasswordResetComponent,
            VerifyEmailComponent,
            AccountManagePasswordComponent,
            ForgotPasswordComponent], imports: [RouterModule,
            CommonModule,
            ReactiveFormsModule,
            RecaptchaModule,
            TranslateModule, E11InputModule, E11ButtonModule, E11PanelModule, E11InputCheckboxModule, E11LoaderDotsModule, i8.E11InputErrorsModule], exports: [AuthComponent,
            LoginComponent,
            VerificationComponent,
            PasswordResetComponent,
            VerifyEmailComponent,
            AccountManagePasswordComponent,
            ForgotPasswordComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: AuthModule, providers: [{ provide: IAuthService, useClass: AuthService }], imports: [RouterModule,
            CommonModule,
            ReactiveFormsModule,
            RecaptchaModule,
            TranslateModule, ImportExportModules, E11InputErrorsModule.forRoot({
                additional: { hasNumberError: 'Include 1 number', passwordMatchError: 'Your passwords do not match' },
            })] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: AuthModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [...DeclareExportComponents],
                    imports: [
                        RouterModule,
                        CommonModule,
                        ReactiveFormsModule,
                        RecaptchaModule,
                        TranslateModule,
                        ...ImportExportModules,
                        E11InputErrorsModule.forRoot({
                            additional: { hasNumberError: 'Include 1 number', passwordMatchError: 'Your passwords do not match' },
                        }),
                    ],
                    providers: [{ provide: IAuthService, useClass: AuthService }],
                    exports: [...DeclareExportComponents],
                }]
        }] });

const defaultConfig = {
    inactivityTimeout: 3600, // one hour,
    warningThreshold: 1800, // 30 minutes
    debounceTime: 60,
    onTimeoutCallback: () => { },
    onWarningCallback: () => { },
};
class ActivityMonitorService {
    constructor(ngZone, logger) {
        this.ngZone = ngZone;
        this.logger = logger;
        this.config = defaultConfig;
        this.lastActivity = Date.now();
        this.warningTriggered = false;
        this.remainingTimeSource = new Subject();
        this.remainingTime$ = this.remainingTimeSource.asObservable();
    }
    get DOMEvents() {
        const events = ['mousedown', 'keypress', 'scroll', 'wheel', 'touchstart'];
        return events.map((event) => fromEvent(document, event));
    }
    start(config) {
        this.config = {
            ...defaultConfig,
            ...config,
            warningThreshold: config.warningThreshold ? config.inactivityTimeout - config.warningThreshold : config.inactivityTimeout / 2,
        };
        const { debounceTime: debounce } = this.config;
        const mousemoves$ = fromEvent(document, 'mousemove');
        this.userActivitySubscription = mousemoves$
            .pipe(mergeWith(...this.DOMEvents))
            .pipe(throttleTime(debounce * 1000), filter(() => !this.warningTriggered))
            .subscribe(() => this.resetTimer());
        this.startTimers();
        this.computeRemainingTime();
        this.logger.info('ActivityMonitorService started: ', this.config);
    }
    stop() {
        this.userActivitySubscription.unsubscribe();
        this.timerSubscription?.unsubscribe();
        this.warningTimerSubscription?.unsubscribe();
        if (this.remainingTimeInterval)
            clearInterval(this.remainingTimeInterval);
    }
    reset() {
        this.resetTimer();
    }
    computeRemainingTime() {
        this.remainingTimeInterval = setInterval(() => {
            const duration = intervalToDuration({
                start: Date.now(),
                end: this.lastActivity + this.config.inactivityTimeout * 1000,
            });
            this.remainingTimeSource.next(duration);
        }, 1000); // fix for TS error
    }
    startTimers() {
        this.startTimer();
        this.warningTimer();
    }
    resetTimer() {
        this.lastActivity = Date.now();
        if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
        }
        if (this.warningTimerSubscription) {
            this.warningTimerSubscription.unsubscribe();
        }
        this.startTimers();
    }
    startTimer() {
        this.ngZone.runOutsideAngular(() => {
            const timeoutInMs = this.config.inactivityTimeout * 1000;
            this.timerSubscription = timer(timeoutInMs).subscribe(() => {
                this.userActivitySubscription.unsubscribe();
                clearInterval(this.remainingTimeInterval);
                this.ngZone.run(() => this.config.onTimeoutCallback());
            });
        });
    }
    warningTimer() {
        this.warningTriggered = false;
        this.ngZone.runOutsideAngular(() => {
            const warningInMs = this.config.warningThreshold * 1000;
            this.warningTimerSubscription = timer(warningInMs).subscribe(() => {
                this.warningTriggered = true;
                this.ngZone.run(() => this.config.onWarningCallback());
            });
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ActivityMonitorService, deps: [{ token: i0.NgZone }, { token: i4.E11Logger }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ActivityMonitorService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ActivityMonitorService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i0.NgZone }, { type: i4.E11Logger }] });

class ActivityMonitorComponent {
    constructor(activityMonitor, modalService) {
        this.activityMonitor = activityMonitor;
        this.modalService = modalService;
        this.inactivityTimeoutSeconds = 0;
        this.warningThreshold = 60;
        this.onTimeout = new EventEmitter();
        this.remainingTime$ = this.activityMonitor.remainingTime$;
    }
    ngOnInit() {
        this.activityMonitor.start({
            inactivityTimeout: this.inactivityTimeoutSeconds,
            onTimeoutCallback: () => this.emitTimeout(),
            onWarningCallback: () => this.openWarning(),
            warningThreshold: this.warningThreshold,
        });
    }
    ngOnDestroy() {
        this.activityMonitor.stop();
    }
    emitTimeout() {
        this.onTimeout.emit();
    }
    openWarning() {
        this.modalService.openModal({
            body: this.modalContent,
            title: 'Session Timeout',
            width: 'sm',
            closeOnEscape: false,
            closeOnClickOutside: false,
            hideCloseButton: true,
        });
    }
    formatTimer(duration) {
        return formatDuration(duration, { format: ['minutes', 'seconds'], zero: true });
    }
    onContinue() {
        this.activityMonitor.reset();
        this.modalService.closeModal();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ActivityMonitorComponent, deps: [{ token: ActivityMonitorService }, { token: i2.E11ModalGlobalService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ActivityMonitorComponent, isStandalone: true, selector: "sdk-auth-activity-monitor", inputs: { inactivityTimeoutSeconds: "inactivityTimeoutSeconds", warningThreshold: "warningThreshold" }, outputs: { onTimeout: "onTimeout" }, viewQueries: [{ propertyName: "modalContent", first: true, predicate: ["modalContent"], descendants: true, static: true }], ngImport: i0, template: `
    <ng-template #modalContent>
      <div class="e11-text-center" *ngrxLet="remainingTime$ as timer">
        <div class="e11-mb-8">
          <p>{{ 'Due to inactivity, your session will expire in:' }}</p>
          <span class="e11-block e11-mb-4 e11-text-lg e11-font-primary-demibold">
            {{ formatTimer(timer) }}
          </span>
          <p>{{ 'Click "Continue" to keep working or click "Sign Out" to end your session now.' | translate }}</p>
        </div>

        <div class="e11-flex e11-gap-4 e11-justify-center e11-items-center">
          <e11-button
            [disabled]="!timer.seconds && !timer.minutes"
            (click)="onContinue()"
            [color]="'primary-accent'"
            [value]="'Continue'"
          ></e11-button>
          <e11-button [disabled]="!timer.seconds && !timer.minutes" (click)="onTimeout.emit()" [color]="'neutral'" [value]="'Sign Out'"></e11-button>
        </div>
      </div>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "ngmodule", type: E11ButtonModule }, { kind: "component", type: i7.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "ngmodule", type: TranslateModule }, { kind: "pipe", type: i9.TranslatePipe, name: "translate" }, { kind: "directive", type: LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ActivityMonitorComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-auth-activity-monitor',
                    standalone: true,
                    imports: [E11ButtonModule, TranslateModule, LetDirective],
                    template: `
    <ng-template #modalContent>
      <div class="e11-text-center" *ngrxLet="remainingTime$ as timer">
        <div class="e11-mb-8">
          <p>{{ 'Due to inactivity, your session will expire in:' }}</p>
          <span class="e11-block e11-mb-4 e11-text-lg e11-font-primary-demibold">
            {{ formatTimer(timer) }}
          </span>
          <p>{{ 'Click "Continue" to keep working or click "Sign Out" to end your session now.' | translate }}</p>
        </div>

        <div class="e11-flex e11-gap-4 e11-justify-center e11-items-center">
          <e11-button
            [disabled]="!timer.seconds && !timer.minutes"
            (click)="onContinue()"
            [color]="'primary-accent'"
            [value]="'Continue'"
          ></e11-button>
          <e11-button [disabled]="!timer.seconds && !timer.minutes" (click)="onTimeout.emit()" [color]="'neutral'" [value]="'Sign Out'"></e11-button>
        </div>
      </div>
    </ng-template>
  `,
                }]
        }], ctorParameters: () => [{ type: ActivityMonitorService }, { type: i2.E11ModalGlobalService }], propDecorators: { modalContent: [{
                type: ViewChild,
                args: ['modalContent', { static: true }]
            }], inactivityTimeoutSeconds: [{
                type: Input,
                args: [{ required: true }]
            }], warningThreshold: [{
                type: Input
            }], onTimeout: [{
                type: Output
            }] } });

// Keeping them, planning to use them for other use cases
const redirectVerifiedTo = (redirect, cb) => pipe(emailVerified, map((emailVerified) => cb(emailVerified) || redirect));
const checkCustomClaimVersionAccepted = (redirect, cb) => pipe(customClaims, map((claims) => cb(JSON.parse(localStorage.getItem('user') || '{}').termsVersionAccepted) || redirect));
/**
 * Routes a logged in user to the /home route (or homePath provided).
 * If using deep linking, this routes the logged in user instead to the route in the deepLink param. This route MUST be in a param named deepLink to work
 * @param homePath -- use to override default redirect
 * @returns
 */
const redirectLoggedInToHome = (homePath = '/home') => {
    return (next, state) => {
        const deepLink = next.paramMap.get('deepLink');
        return redirectLoggedInTo([deepLink || homePath]);
    };
};
/**
 * Only used for the email verification component
 *
 * @param authPath -- use to override default
 * @param homePath -- use to override default
 * @returns a urlTree if no user is present with a target of auth, true to access the the verification page, or a path to the final target
 */
let canAccessVerifyPage = (authPath = 'auth/login', homePath = '/home') => {
    return (next, state) => {
        return pipe(map((user) => {
            return !!user ? user : [authPath, state.url];
        }), map((result) => {
            if (Array.isArray(result)) {
                return result;
            }
            return result.emailVerified ? [next.params.deepLink || homePath] : true;
        }));
    };
};
/**
 * Only used to access terms of use component
 *
 * @param homePath -- use to override default
 * @param emailVerificationPath -- use to override default
 * @returns A urlTree with path to the verification page as the target or the final target of terms are accepted
 */
let canAccessTermsPage = (homePath = '/home', emailVerificationPath = 'auth/register-verify') => {
    return (next, state) => {
        return pipe(emailVerified, map((emailVerified) => {
            if (!emailVerified) {
                return [emailVerificationPath, state.url];
            }
            const accepted = JSON.parse(localStorage.getItem('user') || '{}').termsVersionAccepted;
            if (accepted) {
                return [next.params.deepLink || homePath];
            }
            return true;
        }));
    };
};
/**
 * Used for most every route, supports "deep links" from outside of our application.
 * Ensures that all of the onboarding requirements are met before routing to the final
 * target. These include auth, registration, terms of use, email verification.
 * Example with an override for the auth route:
 *
 * {
    path: 'deep-destination-reg/:jobId/:customerKey',
    component: DeepDestinationComponent,
    ...canActivate(superGuard('login')),
  },
 *
 * @param authPath -- use to override default
 * @param emailVerificationPath -- use to override default
 * @returns The target route if all the onboarding requirements are met
 */
let superGuard = (authPath = 'auth/login', termsPath = 'auth/terms', emailVerificationPath = 'auth/register-verify') => {
    return (next, state) => {
        return pipe(map((user) => {
            return !!user ? user : [authPath, state.url];
        }), map((result) => {
            if (Array.isArray(result)) {
                return result;
            }
            const accepted = JSON.parse(localStorage.getItem('user') || '{}').termsVersionAccepted;
            if (!accepted) {
                return [termsPath, state.url];
            }
            return result.emailVerified ? true : [emailVerificationPath, state.url];
        }));
    };
};
let loggedInOnlyGuard = (authPath = '/auth/login') => {
    return (next, state) => {
        return pipe(map((user) => {
            return !!user ? user : [authPath, state.url];
        }), map((result) => {
            if (Array.isArray(result)) {
                return result;
            }
            else {
                return true;
            }
        }));
    };
};
let userCanAccessVerifyPage = () => canActivate(canAccessVerifyPage());
let userCanAccessTermsPage = () => canActivate(canAccessTermsPage());
let superAuthGuard = () => canActivate(superGuard());
let redirectLoggedInToHomeGuard = () => canActivate(redirectLoggedInToHome());
let loggedInOnlyAuthGuard = () => canActivate(loggedInOnlyGuard());

const DisplayNameRegex = /^[a-zA-Z]([a-zA-Z0-9-]{4,20})$/;
const DomainRegex = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]+\.[a-zA-Z]{2,11}?$/;
const HostRegex = /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9])$/;

function decodeUserJwt(token) {
    return jwt_decode(token);
}

/*
 * Public API Surface of auth
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AUTH_BASE_ROLES, AUTH_ERRORS, AUTH_INVALID_CREDENTIAL, AccountManagePasswordComponent, ActivityMonitorComponent, ActivityMonitorService, AuthComponent, AuthModule, AuthRestService, AuthService, BaseAuthConfigProvider, DisplayNameRegex, DomainRegex, ForgotPasswordComponent, HostRegex, IAuthService, LoginComponent, PLATFORM_ADMIN_ROLES, PasswordResetComponent, TENANT_ROLES, VerificationComponent, VerifyEmailComponent, canAccessTermsPage, canAccessVerifyPage, decodeUserJwt, loggedInOnlyAuthGuard, loggedInOnlyGuard, redirectLoggedInToHome, redirectLoggedInToHomeGuard, superAuthGuard, superGuard, userCanAccessTermsPage, userCanAccessVerifyPage };
